import { teamRoles } from "astrid-firestore/src/constants/teamRoles";

export default function recorderIsPartOfTeam({ production, user }) {
	return !!Object.values(production?.team || {}).find(
		(teamMember) => teamMember.role === teamRoles.RECORDER && teamMember.user?.id === user.id,
	);
}
